import { DiaryTypeEnum } from '../../enum/diary-type.enum';
import { ActivityStatusEnum } from '../../enum/activity-status.enum';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class ActivitiesData {
  StaffName: string;
  StaffId: string;
  ActivityType: DiaryTypeEnum;
  ActivityTypeId: string;
  ActivityDateTime: string;
  SiteName: string;
  SiteReference: string;
  SiteId: string;
  CustomerName: string;
  CustomerReference: string;
  CustomerId: string;
  ScaffoldId: string;
  Area: string;
  ScaffoldNumber: string;
  ScaffoldName: string;
  ScaffoldDescription: string;
  Status: ActivityStatusEnum;
}


